import * as React from "react";
// import './ConfirmModal.scss'
import { IconButton, Tooltip } from "@material-ui/core";
import { useState } from "react";
import { BaseModal } from "../base-modal";
import ResultadoExportcacaoTable from "./ResultadoExportcaoTable";
import Rest from "src/services/Rest";
import { getError } from "src/services/ErrorService";
import GetAppIcon from "@material-ui/icons/GetApp";
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';

import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import ResultadoExportcaoStatus from "./ResultadoExportacaoStatus";
import './ResultadoExportacao.scss'
import FileUtils from "src/services/FileUtils";
import * as path from 'path';
import { Refresh } from "@material-ui/icons";



export const ResultadoExportacao: React.FC = () => {
    const [open, setOpen] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [registros, setRegistros] = useState([])

    const columns = [
        {
            render: (item: any) => <span style={{minWidth: '100px'}}>{item.tipo}</span>,
            title: "Tipo",
            with: 100
        },
        {
            render: (item: any) => <span style={{minWidth: '100px'}}>{item.nome}</span>,
            title: "Solicitado",
            with: 100
        },        
    
        {
            render: (item: any) => <span>{item.dtaalteracao}</span>,
            title: "Data",
        },        
        
    
        {
            render: (item: any) => (
            <div style={{display: 'flex', alignItems: 'center'}}>
                <ResultadoExportcaoStatus status={item.status} /> 
                {item.extra && item.status === 'AGUARDANDO_PROCESSAMENTO' && 
                  <Tooltip placement="top" title="Em até 24 horas" >
                   <AccessAlarmIcon style={{marginLeft: '5px'}} /> 
                  </Tooltip>
                 }
            </div>
             ) ,
            title: "Status",
        },
    
        {
            render: (item: any) => (
              <>          
                {item && item.status === "PROCESSADO" &&  item.url && (
                  <IconButton
                    component={"span"}
                    onClick={() => downloadSheet(item)}                    
                    color="primary"                    
                  >
                    <Tooltip title="Download">
                      <CloudDownloadIcon />
                    </Tooltip>
                  </IconButton>
                )}
              </>
            ),
            title: "Ações",
          },
    ];

    const downloadSheet = (item: any) => { 
        const baseName = path.basename(item.url);       
        Rest.GET("analysis-file", baseName).then((response) => {
          if (response.ok && response.body) {
            FileUtils.downloadXlsx(response.body, decodeURIComponent(baseName));
          } else {
            // openAlert(
            //   "O arquivo solicitado não encontra-se mais disponível",
            //   "error"
            // );
          }
        });
      };

  
    const find = async () => {
        setOpen(true);
        setLoading(true)
        const endPoint = `fila-exportacao`;
        await Rest.GET(endPoint, null)
            .then((response) => response.json())
            .then((result: any) => {
                if (result && result.error) {
                    const erro = getError(result.error);
                    console.log(erro)
                } else {
                    setRegistros(result);
                }
                setLoading(false);
            });
    }

    return (
        <div className="filter-item">
            <IconButton
                onClick={find}
                color="inherit"
                aria-label="Menu"
                className="menu-icon-bar"
                aria-haspopup="true"
            >
             <GetAppIcon />               
            </IconButton>

            <BaseModal.Root open={open} onClose={() => setOpen(false)}  className="resultado-exportcao"  maxWidth={false}>
            <BaseModal.Title 
                label='Relatórios dos últimos 7 dias'
                extraContent={
                  <IconButton onClick={find} color="inherit" aria-label="Refresh" style={{marginLeft: '65%'}}>
                    <Refresh />
                  </IconButton>
                } />
                <BaseModal.Content>
                    <ResultadoExportcacaoTable loading={loading} columns={columns} rows={registros} />
                </BaseModal.Content>
                <BaseModal.Actions>                   
                    <BaseModal.Action label="fechar" onClick={()=> setOpen(false)}/>                 
                </BaseModal.Actions>
            </BaseModal.Root>

        </div>
    )
}


// WEBPACK FOOTER //
// ./src/component/shared/resultado-exportacao/index.tsx